import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_player-captions-on",
  "use": "icon_player-captions-on-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon_player-captions-on\"><path stroke=\"currentColor\" stroke-linecap=\"square\" d=\"M7 15h4m4 0h2M7 11h2m4 0h4M5 5.00001h14L21 5v14H3.00184L3 17V7.00001l.0019-1.99999L5 5.00001Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol